import React, { useEffect, useRef, useState } from 'react';
import { useP } from '../i18n/useP';
import './ExportMenu.css';

/* Export de la vue courante — l'icône télécharger, à DROITE de l'exercice dans
   la barre supérieure (2026-08-21). Elle est passée par le pied du rail, puis
   par la rangée de contrôles sous le filet des onglets ; les deux places la
   faisaient DISPARAÎTRE sur les écrans sans onglets — précisément les récits et
   synthèses qu'on veut imprimer. La barre supérieure est le seul endroit
   présent sur toutes les pages, et elle dit déjà pour QUI et pour QUEL exercice
   on exporte : l'icône y complète la phrase.

   Place permanente ⇒ état permanent : une page qui ne déclare aucun format
   laisse le bouton ATTÉNUÉ (désactivé) plutôt que de le retirer — sinon
   l'absence se lit comme un bogue et on cherche le bouton ailleurs.

   Un seul bouton, un menu avec les formats que la page déclare via
   useRegisterPageExports (Excel · PDF). */
export default function ExportMenu({ options }) {
  const p = useP();
  const [open, setOpen] = useState(false);
  const boxRef = useRef(null);
  const empty = !options?.length;

  useEffect(() => {
    if (!open) return undefined;
    const close = (e) => { if (!boxRef.current || !boxRef.current.contains(e.target)) setOpen(false); };
    const esc = (e) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('mousedown', close);
    document.addEventListener('keydown', esc);
    return () => { document.removeEventListener('mousedown', close); document.removeEventListener('keydown', esc); };
  }, [open]);

  return (
    <div className="app-export" ref={boxRef}>
      <button
        type="button"
        className="app-export__btn"
        title={empty ? p('Cette page ne propose pas d’export') : p('Exporter')}
        aria-haspopup={empty ? undefined : 'menu'}
        aria-expanded={empty ? undefined : open}
        aria-label={p('Exporter')}
        disabled={empty}
        onClick={() => setOpen((v) => !v)}
      >
        <DownloadIcon />
      </button>
      {open && !empty && (
        <div className="app-export__menu" role="menu">
          {options.map((o) => (
            <button
              key={o.id} type="button" role="menuitem" className="app-export__item"
              onClick={() => { setOpen(false); o.run(); }}
            >
              <DownloadIcon /> {o.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

// Icône téléchargement (SVG inline, couleur héritée) — même tracé que le
// bouton Excel des hubs.
function DownloadIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
      strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
      <polyline points="7 10 12 15 17 10" />
      <line x1="12" y1="15" x2="12" y2="3" />
    </svg>
  );
}
